import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { TenantFlow } from '@lib/enums';
import { TenantConfigurationService } from '@lib/services';
import { TenantService } from '@lib/services/tenant.service';

export const tenantAccessGuard = (flow: TenantFlow): CanMatchFn => {
    return () => {
        const tenantConfigurationService = inject(TenantConfigurationService);
        const tenantService = inject(TenantService);
        const tenantKey = tenantService.getTenantKey() || '';
        if (tenantConfigurationService.isTenantAllowed(tenantKey, flow)) {
            return true;
        }

        return false;
    };
};
